/* app/js/src/components/content-control/assets-hub/content-control-assets-hub/content-control-assets-hub.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  margin: 0;
  padding: 25px;
  width: 100vw;
  height: 100%;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  color: rgba(0, 0, 0, 0.85);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  background-color: #eef2f6;
}
.search-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 20px;
}
.search-container .buttons {
  display: flex;
  align-items: center;
  align-self: stretch;
  text-align: center;
}
.search-container .buttons button {
  display: flex;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  text-transform: uppercase;
}
.search-container .buttons button.search {
  background: #2dbbfc;
  color: #ffffff;
  border-color: #2dbbfc;
}
.search-container .filters {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 4px;
}
.search-container .filters input {
  border-radius: 6px;
  padding: 0px 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  outline: none;
  width: 400px;
  height: 39px;
}
.search-container .filters .date-filter {
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 6px;
  padding: 0px 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  width: 250px;
  height: 39px;
  gap: 8px;
}
.grid-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 4px;
  height: 100%;
  background: #ffffff;
}
.grid-container .button-disabled {
  cursor: not-allowed;
  background: rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=content-control-assets-hub.component.css.map */
